import React from "react";
import { IconType } from "react-icons";

export interface ModalItemDropdownOption {
    label: React.ReactNode;
    identifier: string;
    children: React.ReactNode;
}

export interface ModalItemProps {
    order?: number;
    label?: React.ReactNode;
    icon?: IconType;
    identifier: string;
    children?: React.ReactNode;
    main?: boolean;
    /**
     * Optional dropdown options for this tab.
     * When provided, this tab becomes a dropdown with multiple views.
     * Only one dropdown option's children will be rendered at a time.
     * When dropdownOptions is provided, the children prop is ignored.
     */
    dropdownOptions?: ModalItemDropdownOption[];
}

export const ModalItem = (props: ModalItemProps) => { 
    return (
        <>
            {props.children}
        </>
    )
}